import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

/**
 * SafeImage - a drop-in <img> replacement that shows a graceful placeholder
 * if the source fails to load (broken CDN link, network error, empty src, etc).
 *
 * Props: src, alt, className, style, iconClassName, placeholderClassName
 */
export function SafeImage({
    src, alt = '', className = '', style = {},
    iconClassName = 'h-6 w-6', placeholderClassName = '',
    ...rest
}) {
    const [errored, setErrored] = useState(false);

    if (!src || errored) {
        return (
            <div
                className={`flex items-center justify-center bg-neutral-100 text-neutral-400 ${className} ${placeholderClassName}`}
                style={style}
                aria-label={alt || 'image unavailable'}
                role="img"
            >
                <ImageOff className={iconClassName} />
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            style={style}
            loading="lazy"
            onError={() => setErrored(true)}
            {...rest}
        />
    );
}

export default SafeImage;
